export const navigationDefaults = {
  navigationState: {
    __typename: "NavigationState",
    openDrawer: null,
    navigationLevels: []
  }
};
